<div class="breadcrumb-area">
	<h1>Reporte de Cuentas por Cobrar</h1>
</div>
<div class="card mb-3" id="billReceivableGeneralBalanceReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==1?0:1">
		<h3>Antigüedad de Saldos y Reportería</h3>
		<h3><i [ngClass]="selectedReport==1?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==1">
		<div class="row">
			<div class="col-sm-3">
				<div class="form-group">
					<label for="date4" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="date4" name="date4" class="form-control">
				</div>
			</div>
			<div class="col-sm-4 form-group">
				<label for="warehouse" class="form-label">Bodega:</label>
				<select name="warehouse" [(ngModel)]="warehouse" id="warehouse" class="form-select">
					<option value="0">Todas las bodegas</option>
					<option *ngFor="let warehouse of warehouses" value="{{warehouse.id}}">{{warehouse.name}}</option>
				</select>
			</div>
			<div class="col-sm-3">
				<div class="form-group">
					<label for="filterOldAccountReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterOldAccountReport" placeholder="Buscar en saldos generales"
						name="filterOldAccountReport" class="form-control" 
						[(ngModel)]="filterWordReport1"
						(input)="onInputChangeReport1($event)"
						>
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getBillReceivableGeneralBalanceReport('excel')"
					data-bs-toggle="tooltip" title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getBillReceivableGeneralBalanceReport('pdf')"
					data-bs-toggle="tooltip" title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" (click)="getBillReceivableGeneralBalanceReport('json')"
					data-bs-toggle="tooltip" title="Ver Reporte"><i class="fa fa-eye"></i></button>
			</div>
			<ng-container *ngIf="paginationAccountsReport1.total.length > 0">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th>Código</th>
								<th>Proveedor</th>
								<th>Saldo</th>
								<th>1 a 30 días</th>
								<th>31 a 60 días</th>
								<th>61 a 90 días</th>
								<th>91 o más días</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let vendor of paginationAccountsReport1.filter">
								<td>{{vendor.code}}</td>
								<td>{{vendor.name}}</td>
								<td>{{vendor.balance}}</td>
								<td>{{vendor.total30?vendor.total30:0}}</td>
								<td>{{vendor.total60?vendor.total60:0}}</td>
								<td>{{vendor.total90?vendor.total90:0}}</td>
								<td>{{vendor.totaln?vendor.totaln:0}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationAccountsReport1.total.length > 0" [elements]="paginationAccountsReport1"></app-pagination-custom>
			</ng-container>
		</div>
	</div>
</div>
<div class="card mb-3" id="billToReceivableList">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==2?0:2">
		<h3>Control de Saldos por Clientes y Reportería</h3>
		<h3><i [ngClass]="selectedReport==2?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==2">
		<div class="row">
			<div class="col-sm-10">
				<div class="form-group">
					<label for="filterBalanceByClientReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterBalanceByClientReport" placeholder="Buscar Cliente"
						name="filterBalanceByClientReport" class="form-control"
						[(ngModel)]="filterWordReport2"
						(input)="onInputChangeReport2($event)">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getBillToReceivableList('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getBillToReceivableList('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" (click)="getBillToReceivableList('json')" data-bs-toggle="tooltip"
					title="Ver Reporte"><i class="fa fa-eye"></i></button>
			</div>
			<ng-container *ngIf="paginationAccountsReport2.total.length > 0">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th>Código</th>
								<th>NIT</th>
								<th>Cliente</th>
								<th>Saldo</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let client of paginationAccountsReport2.filter">
								<td>{{client.code}}</td>
								<td>{{client.nit}}</td>
								<td>{{client.name}}</td>
								<td>{{client.balance}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationAccountsReport2.total.length > 0"
					[elements]="paginationAccountsReport2"></app-pagination-custom>
			</ng-container>
		</div>
	</div>
</div>

<div class="card mb-3" id="billReceivableRecurrence">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==3?0:3">
		<h3>Facturación Recurrente</h3>
		<h3><i [ngClass]="selectedReport==3?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==3">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate3" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate3" name="startDate3" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="date3" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="date3" name="date3" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="recurrence3" class="form-label">Tipo: </label>
					<select name="recurrence3" [(ngModel)]="recurrence" id="recurrence3" class="form-select">
						<option value="0" selected="selected">Selecciona una recurrencia</option>
						<option value="1">
							Semanal
						</option>
						<option value="2">
							Quincenal
						</option>
						<option value="3">
							Mensual
						</option>
						<option value="4">
							Bimestral
						</option>
						<option value="5">
							Trimestral
						</option>
						<option value="6">
							Semestral
						</option>
						<option value="7">
							Anual
						</option>
						<option value="8">
							Diario
						</option>
						<option value="9">
							Especial
						</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterBillReceivableRecurrence" class="form-label">Búsqueda</label>
					<input type="text" id="filterBillReceivableRecurrence" placeholder="Busca en Saldos Generales"
						name="filterBillReceivableRecurrence" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getBillReceivableRecurrence('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getBillReceivableRecurrence('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
						class="fa fa-eye"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="IntegrationRecurrence">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==4?0:4">
		<h3>Integración Facturas Recurrentes</h3>
		<h3><i [ngClass]="selectedReport==4?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==4">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate4" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate4" name="startDate4" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="date4" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="date4" name="date4" class="form-control">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getIntegratedRecurrence('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel">
					
				</button>
				<button class="btn btn-primary" (click)="getIntegratedRecurrence('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="CXCReport">
    <div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==7?0:7">

		<h3>Reporte CxC</h3>

		<h3>
			<i [ngClass]="selectedReport==7?'fa-minus':'fa-plus'"
			class="fa">
			</i>
		</h3>
	</div>

    <div class="card-body" *ngIf="selectedReport==7">
        <div class="row align-items-end">

            <div class="col-sm-4">
                <div class="form-group">
                    <label for="warehouseCXC" class="form-label">
                        Bodega:
                    </label>

                    <select
                        name="warehouseCXC"
                        [(ngModel)]="warehouseCXC"
                        id="warehouseCXC"
                        class="form-select">

                        <option [ngValue]="0">
                            Todas las bodegas
                        </option>

                        <option
                            *ngFor="let warehouse of warehouses"
                            [ngValue]="warehouse.id">
                            {{warehouse.name}}
                        </option>

                    </select>
                </div>
            </div>

            <div class="col-sm-2 download-buttons">

                <button
                    class="btn btn-success"
                    (click)="getCXCReport('excel')"
                    data-bs-toggle="tooltip"
                    title="Descargar Excel"
                    [disabled]="loadingReport[5]">

                    <span
                        class="spinner-border spinner-border-sm"
                        aria-hidden="true"
                        *ngIf="loadingReport[5]">
                    </span>

                    <i
                        class="fa fa-file-excel"
                        *ngIf="!loadingReport[5]">
                    </i>
                </button>

                <button
                    class="btn btn-primary"
                    (click)="getCXCReport('pdf')"
                    data-bs-toggle="tooltip"
                    title="Descargar PDF"
                    [disabled]="loadingReport[5]">

                    <span
                        class="spinner-border spinner-border-sm"
                        aria-hidden="true"
                        *ngIf="loadingReport[5]">
                    </span>

                    <i
                        class="fa fa-file-pdf"
                        *ngIf="!loadingReport[5]">
                    </i>
                </button>

            </div>
        </div>
    </div>
</div>

<div class="card mb-3" id="StatementReportGeneral">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==5?0:5">
		<h3>Estado de cuenta CxC General</h3>
		<h3><i [ngClass]="selectedReport==5?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==5">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate5" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate5" name="startDate5" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="date5" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="date5" name="date5" class="form-control">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getStatementReportGeneral('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel" [disabled]="loadingReport[6]">
					<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingReport[6]"></span>
					<i class="fa fa-file-excel" *ngIf="!loadingReport[6]"></i>
				</button>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="StatementReportGeneral">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==6?0:6">
		<h3>Estado de cuenta CxC por Cliente</h3>
		<h3><i [ngClass]="selectedReport==6?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==6">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate3" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate3" name="startDate3" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="endDate3" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate3" name="endDate3" class="form-control">
				</div>
			</div>
			<div>
				<div>
					<div class="form-group">
						<label for="client-input" class="form-label">Cliente</label>
						<div class="input-group input-group-sm" style="margin-bottom: 1em;">
							<app-input-autocomplete [ruleToDisabled]="clients.length == 0" [allBorderRadius]="true"
							[inputs]="client" [placeholder]="'Ingresa el nit o el nombre de un cliente'"
							[filterElements]="client.filterElements" [typeElements]="'client'" (inputMethod)="writeClient()"
							(changeStatus)="selectClient($event.filterElement,1)" [custom]="true">
							<ng-template #itemsTemplate let-filter>
								<div items>
								<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
									{{filter.name}}</h5>
								<span style="color: white;">NIT: <b>{{filter.nit}}</b></span>
								</div>
							</ng-template>
							</app-input-autocomplete>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button class="btn btn-success" (click)="getStatementReportFilter('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel" [disabled]="loadingReport[7]">
					<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingReport[7]"></span>
					<i class="fa fa-file-excel" *ngIf="!loadingReport[7]"></i>
				</button>
			</div>
		</div>
	</div>
</div>